import {Injectable} from '@angular/core';


export interface PieStatuses {
  '-2': number;
  '-1': number;
  0: number;
  1: number;
  2: number;
  3: number;
}

@Injectable()
export class PieService {


  private colorArray = ['-1', 0, 1, 2, 3, 4]; // Цвета и последовательность в которой они будут отображены

  private colors = {
    1: '#31ac51',
    2: '#EE9946',
    3: '#F95C5D',
    4: '#a20000',
    0: '#7E8087',
    '-1': '#85B3CB'
  };

  create(statuses: PieStatuses, size): { path: string; color: string }[] {
    const data = [];
    let allCount = 0;
    this.colorArray.forEach((color: any) => {
      allCount += statuses[color] || 0;
    });
    let cumulativePercent = 0;
    this.colorArray.forEach((color: any) => {
      const count = statuses[color];
      if (!count) {
        return;
      }
      const percent = count / allCount;
      const [startX, startY] = this.getCoordinatesForPercent(size, cumulativePercent);
      cumulativePercent += percent;
      const [endX, endY] = this.getCoordinatesForPercent(size, cumulativePercent);

      const largeArcFlag = percent > .5 ? 1 : 0;

      const pathData = [
        `M ${startX} ${startY}`, // Move
        `A 20 20 0 ${largeArcFlag} 1 ${endX} ${endY}`, // Arc
        `L 0 0`, // Line
      ].join(' ');

      data.push({
        path: pathData,
        color: this.colors[color + '']
      });
    });
    return data;
  }

  private getCoordinatesForPercent(size, percent) {
    const x = size / 2 * Math.cos(2 * Math.PI * percent);
    const y = size / 2 * Math.sin(2 * Math.PI * percent);
    return [x, y];
  }

}

